import React from 'react';
import ScrollToTop from './ScrollToTop';
import '../styles/blog-overrides.scss';

const BlogLayout = ({ children }) => {
  return (
    <div className="blog-page flex flex-col min-h-screen bg-background-dark text-slate-100 font-display">
      <ScrollToTop />
      <main className="flex-grow" role="main" aria-label="Main content">
        {children}
      </main>
    </div>
  );
};

export default BlogLayout; 